(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e) {
  var tab = e.target.closest('.sp-cat-tabs span');
  if (!tab) return;

  var wrap = tab.closest('[id^="studio-palm-home-"]');
  if (!wrap) return;

  var tabs = wrap.querySelectorAll('.sp-cat-tabs span');
  var items = wrap.querySelectorAll('.sp-grid-item');

  tabs.forEach(function(t) { t.classList.remove('active'); });
  tab.classList.add('active');
  var filter = tab.getAttribute('data-filter');

  items.forEach(function(item) {
    var cat = item.getAttribute('data-category');
    if (filter === 'All' || cat === filter) {
      item.style.display = '';
    } else {
      item.style.display = 'none';
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-portfolio"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e) {
  var wrap = e.target.closest('[id^="sp-portfolio-page-"]');
  if (!wrap) return;

  var lightbox = wrap.querySelector('.sp-lightbox');
  var lightboxImg = lightbox.querySelector('img');

  var item = e.target.closest('.sp-grid-item');
  if (item) {
    lightboxImg.src = item.getAttribute('data-full');
    lightbox.classList.add('open');
    return;
  }

  if (e.target.closest('.sp-lightbox-close') || e.target === lightbox) {
    lightbox.classList.remove('open');
  }
});

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    document.querySelectorAll('.sp-lightbox.open').forEach(function(lb) {
      lb.classList.remove('open');
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-palm-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e) {
  var tab = e.target.closest('.sp-cat-tabs span');
  if (!tab) return;

  var wrap = tab.closest('[id^="studio-palm-home-"]');
  if (!wrap) return;

  var tabs = wrap.querySelectorAll('.sp-cat-tabs span');
  var items = wrap.querySelectorAll('.sp-grid-item');

  tabs.forEach(function(t) { t.classList.remove('active'); });
  tab.classList.add('active');
  var filter = tab.getAttribute('data-filter');

  items.forEach(function(item) {
    var cat = item.getAttribute('data-category');
    if (filter === cat) {
      item.style.display = '';
    } else {
      item.style.display = 'none';
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
